import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { UserConfigsService } from '../services/user-configs.service';
import { UserConfigs } from '../models/user-configs.model';

@Injectable({
  providedIn: 'root'
})
export class DeletedCaseGuard  {

  constructor(
    private readonly userConfigService: UserConfigsService,
    private readonly router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.userConfigService.getUserConfigs().pipe(
      take(1),
      map(uc => this.redirectWhenCaseDeleted(uc))
    );
  }

  redirectWhenCaseDeleted(userConfigs: UserConfigs): boolean | UrlTree {
    if (!userConfigs.currentCase)
      return this.router.createUrlTree(['/select-case'], { queryParams: { suppressMenu: 'true' } });
    else
      return true;
  }
}